module.exports = __webpack_public_path__ + "img/2-7.8dd6100e.png";